import {
  formatCurrency,
  formatPercentage,
  translate,
} from "@/utils/formatters";

import { VatGroup } from "../../../types/receipt";

interface VatLineProps {
  group: VatGroup;
  currencyCode: string;
  lang: string;
}

export const VatLine = ({ group, currencyCode, lang }: VatLineProps) => {
  const vatName =
    group.name && group.name.toUpperCase() === "MVA"
      ? translate(lang, "MVA", "VAT")
      : group.name ?? translate(lang, "MVA", "VAT");

  return (
    <p className="small amount">
      {formatCurrency(group.amount ?? 0, currencyCode)} {vatName}{" "}
      {formatPercentage(group.percentage)}
    </p>
  );
};
